import { Component } from '@angular/core';

@Component({
  selector: 'app-log-tracking-link',
  templateUrl: './log-tracking-link.component.html',
  styleUrls: ['./log-tracking-link.component.scss']
})
export class LogTrackingLinkComponent {

}
